import { handleRequest } from "../utilities/requestHandler";

export const processModel = (endpoint, filename, machineName, currency, userId, productNumbers, machineId, baseColor, selectedSite, machineNumber) =>
    handleRequest("post", endpoint, {
        filename: filename,
        machinename: machineName,
        currency: currency,
        loggedinUser: userId,
        productNumbers: productNumbers,
        ecommachineid: machineId,
        baseColor: baseColor,
        selectedSite: selectedSite,
        machinenumber: machineNumber,
    });